import api from '@/services/api';
import { notify } from '@/services/notify';

export default {
    async _presignedUrl(resource) {
        const response = await api.get(`/${resource}/upload-url`);
        return {
            url: response.data.url,
            fields: response.data.fields,
            prefix: response.data.fields.key.replace('${filename}', ''),
        };
    },
    async _uploadToS3(presignedUrl, files, updateCallback) {
        let progressCurrent = 0;
        const progressMax = files.length;
        let i = 0;
        let oids = [];
        for (const file of files) {
            const oid = crypto.randomUUID();
            presignedUrl.fields.key = presignedUrl.prefix + oid;
            let form = new FormData();
            for (const field in presignedUrl.fields) {
                form.append(field, presignedUrl.fields[field]);
            }
            form.append('file', file);

            i += 1;
            await api.postToS3(presignedUrl.url, form, (progressEvent) => {
                progressCurrent += progressEvent.progress;
                updateCallback((progressCurrent / progressMax) * 100, `Uploading file ${i} of ${progressMax}`);
            });
            oids.push(oid);
        }
        return oids;
    },
    async _requestImport(oids, resource) {
        const response = await api.postJSON(`/${resource}/import-task`, oids);
        if (response.data.id) {
            notify().success("Your task is in progress. Please check the task list to see when the import has finished.");
        }
        else {
            notify().error("Failed to start import task.");
        }
    },
    async json(files, updateCallback, resource) {
        updateCallback(0, 'Preparing to upload');
        const presignedUrl = await this._presignedUrl(resource);
        const oids = await this._uploadToS3(presignedUrl, files, updateCallback);
        updateCallback(100, 'Importing...');
        await this._requestImport(oids, resource);
    },
}
